import { InteractionRequiredAuthError } from "@azure/msal-browser";

export const getAccountByTenantId = (accounts, tenantId) => {
  if (!accounts || accounts.length === 0) {
    throw new Error("No accounts available");
  }

  if (!tenantId) {
    return accounts[0];
  }

  const matchingAccount = accounts.find(account => account.tenantId === tenantId);
  
  if (!matchingAccount) {
    console.warn(`No account found for tenant ID: ${tenantId}. Using first available account.`);
    return accounts[0];
  }

  return matchingAccount;
};

export const getAuthenticatedAccount = async (instance, accounts, tenantId) => {
  const account = getAccountByTenantId(accounts, tenantId);
  
  try {
    await instance.acquireTokenSilent({
      scopes: [process.env.REACT_APP_AUTH_SP_SCOPE],
      account: account,
    });
    return account;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await instance.acquireTokenPopup({
        scopes: [process.env.REACT_APP_AUTH_SP_SCOPE],
        account: account,
      });
      return account;
    }
    throw error;
  }
}; 